import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { getStatuses, addStatus, updateStatus } from "../api/statusApi";
import { showError } from "../utils/alert";

export default function StatusForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEdit) {
      loadStatus();
    }
  }, [id]);

  const loadStatus = async () => {
    try {
      // fetch a large page to ensure the id is included
      const res = await getStatuses({ page: 1, per_page: 1000 });
      const status = res.data.items.find((s) => s.id === parseInt(id));
      if (status) {
        setName(status.name);
      } else {
        showError("Status not found");
        navigate("/statuses");
      }
    } catch (err) {
      showError("Failed to load status");
      navigate("/statuses");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return showError("Status name is required");

    setLoading(true);
    try {
      if (isEdit) {
        await updateStatus(id, { name });
      } else {
        await addStatus({ name });
      }
      navigate("/statuses");
    } catch (err) {
      showError(isEdit ? "Failed to update status" : "Failed to add status");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout title={isEdit ? "Edit Status" : "Add Status"}>
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title mb-3">
            {isEdit ? "Edit Status" : "Add New Status"}
          </h5>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Status name</label>
              <input
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter status name"
                required
              />
            </div>
            <div className="d-flex gap-2">
              <button
                type="submit"
                className="btn skedq-accent-btn"
                disabled={loading}
              >
                {loading ? "Saving..." : isEdit ? "Update" : "Add"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => navigate("/statuses")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
}
